'use strict'

function getSettlementDisplay(status, totalShuying) {
  if (totalShuying === undefined || totalShuying === null || totalShuying === '') {
    return status
  }
  return totalShuying
}

module.exports = {
  getSettlementDisplay
}



// WEBPACK FOOTER //
// ./src/common/betStatus.js